module.exports = __webpack_public_path__ + "d941c9c516a92e4a0252c9345fe33709.svg";